<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
          <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  hide-details
                  v-model="formatedDate"
                  label="Zeitraum"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                type="month"
                scrollable
                locale="de"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="modal = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="setDate(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col class="pt-3 pb-0 text-right" >
          <b-button variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="showCreate = true">
            Rufer festlegen
          </b-button>
          <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
            &nbsp;Zurück
          </b-button>

        </v-col>
      </v-row>
      <v-row class="m-0">
        <v-col>
          <v-card
              style="width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="blue"
                :weekday-format="myDayFormat"
                :month-format="myMonthFormate"
                :event-ripple="false"
                :events="events"
                type="month"
                :weekdays="weekdayOrder"
                @change="onCalendarDateChange"
                @click:day="onDayClicked"
                @click:more="onMoreClicked"
                event-more-text="Mehr anzeigen"
            >
              <template v-slot:day-label="{date, day, present, month}">
                <v-row class="m-0" style="margin-top: -6px !important;">
                  <v-col md="9" class="p-1 text-left">
                    <v-chip
                        v-if="date in holidays"
                        class="soll-ist zero text-truncate"
                        label small
                    >
                      {{holidays[date]}}
                    </v-chip>
                  </v-col>
                  <v-col v-if="!present" md="3" class="p-1"><v-btn fab  x-small depressed>{{day}}</v-btn></v-col>
                  <v-col v-else md="3" class="p-1 text-left"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
                </v-row>
              </template>
              <template v-slot:event="{ event, timed, eventSummary }" >
                <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']">
                  <!--component :is="{ render: eventSummary }"></component-->
                  <div class="v-event-summary" style="color: white">{{event.name}}</div>
                </div>
              </template>
            </v-calendar>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
          v-model="showMore"
          max-width="450px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufer für {{moreDate}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="v-calendar-monthly v-calendar-weekly v-calendar theme--light v-calendar-events" role="grid" style="border: none;">
                <div role="row" class="v-calendar-weekly__week">
                  <div class="v-calendar-weekly__day-label" style="width: 100%;">
                    <div v-for="e in moreEvents" class="v-event v-event-start v-event-end white--text mt-1"
                         :style="{'height': '20px', 'width': '100%', 'margin-bottom': '1px', 'background-color': e.color, 'border-color': e.color}">
                      <div data-v-341adc5c="" class="clickable v-event-draggable">
                        <div data-v-341adc5c="" class="v-event-summary" style="color: white;">{{e.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelShowMore"
            >
              Zurück
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showModify"
          max-width="450px"
          persistent
          @click:outside="onCancelModify"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufer für {{modifyDate}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="v-calendar-monthly v-calendar-weekly v-calendar theme--light v-calendar-events" role="grid" style="border: none;">
                <div role="row" class="v-calendar-weekly__week">
                  <div class="v-calendar-weekly__day-label" style="width: 100%; cursor: auto">
                    <div v-for="e in modifyEvents" class="v-event v-event-start v-event-end white--text mt-1"
                         :style="{'cursor': 'auto', 'pointer-events': 'all', 'height': '20px', 'width': '100%', 'margin-bottom': '1px', 'background-color': e.color, 'border-color': e.color}">
                      <div data-v-341adc5c="">
                        <v-row>
                          <v-col md="9">
                        <div data-v-341adc5c="" class="v-event-summary" style="text-align: start; padding-left: 12px; color: white; cursor: auto">{{e.name}}</div>
                          </v-col>
                            <v-col md="3">
                              <v-icon small
                                      style="float: right; margin-top: 2px; margin-right: 12px; cursor: pointer"
                                      color="white"
                                      @click="onModifyDelete(e.id)"
                              >
                                mdi-delete
                              </v-icon>

                            </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                  style="margin-top: 14px"
                  v-model="selectedCallers"
                  :items="possibleCallers"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  label="Rufer auswählen"
                  hint="Mitarbeiter die an diesem Tag als Rufer fungieren."
                  persistent-hint
              ></v-select>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelModify"
            >
              Zurück
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSaveModify"
                :disabled="!saveNeeded"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showCreate"
          max-width="450px"
          persistent
          @click:outside="onCancelCreate"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufer festlegen</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-dialog
                  ref="dialog_select_start"
                  v-model="startSelectModal"
                  :return-value.sync="startSelectModal"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDateCallerStart"
                      label="Startdatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startCallerDate"
                    :picker-date.sync="selectedMonthModal"
                    :allowed-dates="allowedDatesStart"
                    type="date"
                    scrollable
                    locale="de"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="startSelectModal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setCallerStart(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-dialog
                  ref="dialog_select_end"
                  v-model="endSelectModal"
                  :return-value.sync="endSelectModal"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDateCallerEnd"
                      label="Enddatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="endCallerDate"
                    :picker-date.sync="selectedMonthModal"
                    :allowed-dates="allowedDatesEnd"
                    type="date"
                    scrollable
                    locale="de"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="endSelectModal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setCallerEnd(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-select
                  style="margin-top: 14px"
                  v-model="selectedCallers"
                  :items="possibleCallers"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  label="Rufer auswählen"
                  hint="Mitarbeiter die in diesem Zeitraum als Rufer fungieren."
                  persistent-hint
              ></v-select>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelCreate"
            >
              Zurück
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSaveCreate"
                :disabled="!saveNeeded || startCallerDate === null || endCallerDate === null"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showConflictDialog"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title>
            Es sind Konflikte aufgetreten
          </v-card-title>
          <v-card-subtitle class="mt-0">
            Bitte wählen Sie aus wie mit folgenden Konflikten umgegangen werden soll.
          </v-card-subtitle>
          <v-card-text>
            <v-container class="p-0">
              <v-row>
                <v-col>
                  <span class="text-h6" style="font-weight: 400;color: black;">Überschneidungen mit Urlaub</span>
                  <v-card-subtitle class="mt-0 p-0">
                    Sie können die Rufer entweder dennoch zuweisen oder an Urlaubstagen aussetzen.
                  </v-card-subtitle>
                  <v-radio-group
                      v-model="shouldApplyToHolidays"
                      column
                  >
                    <v-radio
                        label="Dennoch zuweisen"
                        value="true"
                    ></v-radio>
                    <v-radio
                        label="An Urlaubstagen aussetzen"
                        value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelConflict"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitConflict"
                :disabled="shouldApplyToHolidays === '' "
            >
              Absenden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-main>
</template>

<script>
import _orderBy from "lodash/orderBy";
import {Cookie_Path, Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _throttle from "lodash/throttle";
import {getUid} from "@/shared/crypto";

export default {
  name: "CallerCalendar",
  data: () => ({
    focus: '',
    mitas: [],
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "July", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,
    startDate: null,
    endDate: null,

    date: new Date().toISOString().substr(0, 7),
    modal: false,

    // caller specific
    holidays: [],
    callers: [],
    events: [],

    search: '',

    // confict data
    showConflictDialog: false,
    shouldApplyToHolidays: '',

    // controls

    // more
    showMore: false,
    moreDate: "",
    moreDateObject: {},

    // modify
    showModify: false,
    modifyEvents: [],
    deletedModifyEvents: [],
    modifyDate: "",
    modifyDateObject: null,
    selectedCallers: [],
    showCreate: false,

    startSelectModal: false,
    startCallerDate: null,
    endSelectModal: false,
    endCallerDate: null,
    selectedMonthModal: "",
  }),
  computed: {
    filteredItems() {
      return _orderBy(this.mitas.filter(item => {
        if(!this.search) return this.mitas;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },

    formatedDate() {
      let splits = this.date.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },

    moreEvents() {
      let moreEvents = [];
      for (let i = 0; i < this.events.length; i++) {
        let parsed = this.$refs.calendar.parseEvent(this.events[i]);
        if (parsed.start.date === this.moreDateObject.date) {
          moreEvents.push(this.events[i]);
        }
      }
      return moreEvents;
    },
    possibleCallers() {
      let pos = [];
      for (let i = 0; i < this.mitas.length; i++) {
        let found = false;
        for (let j = 0; j < this.modifyEvents.length; j++) {
          if (this.mitas[i].id === this.modifyEvents[j].mita_id) {
            found = true;
            break;
          }
        }
        if (!found) {
          pos.push(this.mitas[i]);
        }
      }
      return _orderBy(pos, [val => val.name.toLowerCase()])
    },
    saveNeeded() {
      return this.deletedModifyEvents.length !== 0 || this.selectedCallers.length !== 0
    },
    formatedDateCallerStart() {
      if (this.startCallerDate) {
        return this.startCallerDate.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
    formatedDateCallerEnd() {
      if (this.endCallerDate) {
        return this.endCallerDate.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
  },
  mounted () {
    this.$refs.calendar.updateTimes()
  },
  created() {
    // todo add payload
    console.log("created")
    console.log(this.startDate)
    console.log(this.endDate)
  },
  methods: {
    allowedDatesStart(val) {
      if (this.endCallerDate) {
        return new Date(val).getTime() <= new Date(this.endCallerDate).getTime();
      } else {
        return true;
      }
    },
    allowedDatesEnd(val) {
      if (this.startCallerDate) {
        return new Date(val).getTime() >= new Date(this.startCallerDate).getTime();
      } else {
        return true;
      }
    },
    setCallerStart(date) {
      this.$refs.dialog_select_start.save(date);
    },
    setCallerEnd(date) {
      this.$refs.dialog_select_end.save(date);
    },
    onDayClicked(d, event) {
      event.preventDefault();
      event.stopPropagation();
      this.modifyDate = d.date.split("-").reverse().join(".")
      this.modifyDateObject = d;
      // todo show edit callers
      this.modifyEvents = [];
      for (let i = 0; i < this.events.length; i++) {
        let parsed = this.$refs.calendar.parseEvent(this.events[i]);
        if (parsed.start.date === this.modifyDateObject.date) {
          this.modifyEvents.push(this.events[i]);
        }
      }
      this.showModify = true;
    },
    onModifyDelete(id) {
      console.log(id)
      for (let i = 0; i < this.modifyEvents.length; i++) {
        if (this.modifyEvents[i].id === id) {
          this.deletedModifyEvents.push(this.modifyEvents[i].id);
          this.modifyEvents.splice(i, 1);
          break;
        }
      }
    },
    onCancelModify() {
      this.showModify = false
      this.selectedCallers = [];
      this.modifyEvents = [];
      this.deletedModifyEvents = [];
      this.modifyDate = "";
      this.modifyDateObject = null;
    },
    onSaveModify() {
      let data = {
        from: this.modifyDateObject.date,
        to: this.modifyDateObject.date,
        insert_ids: this.selectedCallers,
        delete_ids: this.deletedModifyEvents,
        is_init: true,
        range_start: this.startDate.date,
        range_end: this.endDate.date,
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/callers', data
      ).then(this.responseOkChangeCaller, this.responseErrorChangeCaller)
    },

    onCancelCreate() {
      this.showCreate = false
      this.selectedCallers = [];
      this.modifyEvents = [];
      this.deletedModifyEvents = [];
      this.modifyDate = "";
      this.modifyDateObject = null;
      this.startCallerDate = null;
      this.endCallerDate = null;
    },
    onSaveCreate() {
      let data = {
        from: this.startCallerDate,
        to: this.endCallerDate,
        insert_ids: this.selectedCallers,
        is_init: true,
        range_start: this.startDate.date,
        range_end: this.endDate.date,
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/callers', data
      ).then(this.responseOkChangeCaller, this.responseErrorChangeCaller)
    },
    responseOkChangeCaller(response) {
      this.hideLoader();
      this.onCancelCreate()
      this.onCancelModify()
      if (response.status === 200) {
        this.callers = response.body.callers;
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    responseErrorChangeCaller(response) {
      this.hideLoader();
      if (response.status === 409) {
        console.log(response)
        this.showConflictDialog = true;
      } else if (response.status === 401) {
        console.log(response);
        window.location = Redirect_Login;
      } else {
        console.log(response);
        window.location = Redirect_500;
      }
    },
    formatInterval(a) {
      if (a.minute === 0) {
        return a.time;
      }
    },
    onMoreClicked(d, event) {
      event.preventDefault();
      event.stopPropagation();
      this.moreDate = d.date.split("-").reverse().join(".")
      this.moreDateObject = d;
      this.showMore = true;
    },
    onCancelShowMore() {
      this.showMore = false;
    },
    onCalendarDateChange(event) {
      this.showLoader();
      this.currentMonth = this.$refs.calendar.parsedValue.month;
      this.currentYear = this.$refs.calendar.parsedValue.year;
      this.selectedMonth = this.currentYear.toString() + "-" + this.currentMonth.toString().padStart(2, "0");
      this.startDate = this.$refs.calendar.getStartOfWeek(event.start);
      this.endDate = this.$refs.calendar.getEndOfWeek(event.end);
      this.selectedMonthModal = this.selectedMonth;
      let data = {
       from: this.startDate.date,
       to: this.endDate.date,
     }
     this.$http.post(
         Server_URL_ZK + '/zk/rufbereitschaft/callers/calendar', data
     ).then(this.responseOkGet, this.responseError)
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.holidays = response.body.all_holidays;
        for (let i = 0; i < response.body.mitas.length; i++) {
          let mita = response.body.mitas[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitas.push(mita)
        }
        this.callers = response.body.callers;
        console.log(this.mitas)
        console.log(this.callers)
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    calculateEvents() {
      let events = [];
      // rb color
      let rbColor = "#ea5324"
      let holColor = "#2463ea"

          for (let i = 0; i < this.callers.length; i++) {
            let cur = this.callers[i];
            let mita = {name: ""};
            for (let j = 0; j < this.mitas.length; j++) {
              if (this.mitas[j].id === cur.id) {
                mita = this.mitas[j];
                break
              }
            }
            for (let j = 0; j < cur.callers.length; j++) {
              let date = cur.callers[j].date;
              let start = Date.parse(date);
              let end = Date.parse(date);
              events.push({
                id: cur.callers[j].id,
                name: mita.name,
                start: start,
                end: end,
                color: rbColor,
                timed: false,
                mita_id: mita.id,
                eventType: "caller",
              })
            }
          }

      this.events = events;
    },
    responseError(response) {
      console.log(response);
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setDate(date) {
      this.$refs.dialog.save(date);
      this.focus = date+"-01";
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    onBack() {
      window.history.back();
    },
    // helpers
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : event.color
    },
    formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    // conflict handling
    onCancelConflict() {
      this.onCancelCreate()
      this.onCancelModify()
    },

    onSubmitConflict() {
      let data = {}
      if (this.showCreate) {
        data = {
          from: this.startCallerDate,
          to: this.endCallerDate,
          insert_ids: this.selectedCallers,
          is_init: false,
          on_holiday: this.shouldApplyToHolidays === 'true',
          range_start: this.startDate.date,
          range_end: this.endDate.date,
        }
      } else {
        data = {
          from: this.modifyDateObject.date,
          to: this.modifyDateObject.date,
          insert_ids: this.selectedCallers,
          delete_ids: this.deletedModifyEvents,
          is_init: false,
          on_holiday: this.shouldApplyToHolidays === 'true',
          range_start: this.startDate.date,
          range_end: this.endDate.date,
        }
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/callers', data
      ).then(this.responseOkChangeCaller, this.responseError)
      this.showConflictDialog = false;
      this.shouldApplyToHolidays = '';
    },
    isElectron() {
      let userAgent = navigator.userAgent.toLowerCase();
      return userAgent.indexOf(' electron/') > -1;
    },
    setCookie(keyName, value, expireTimes, path, domain, secure) {
      this.$cookies.set(keyName, value, expireTimes, path, domain, secure);
      if (this.isElectron()) {
        window.top.postMessage(
            {
              typ: 'cookie',
              keyName: keyName,
              value: value,
              expireTimes: expireTimes,
              path: path,
              domain: domain,
              secure: secure
            }, "*");
      }
    },
  }
}
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}
.v-list-group__header__prepend-icon {
  margin-right: 8px !important;
}

</style>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #63c2de;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

.theme--light::v-deep.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: 0px;
}

.theme--light::v-deep.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  color: #000000 !important;
}

.v-chip::v-deep .v-chip__content {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: inline-block;
  text-align: center;
  padding-top: 2px;
}

.v-calendar::v-deep.v-calendar-events .v-calendar-weekly__day {
  margin-right: 0px;
}

.v-list-group__header__prepend-icon::v-deep {
  margin-right: 8px !important;
}

</style>
